import React from 'react';
import PropTypes from 'prop-types';
import { Controller } from 'react-hook-form';

const withController = (ComponentWithController, defaultValueFallback = '') => {
  const WrappedComponent = ({
    rules,
    name,
    control,
    defaultValue,
    ...properties_
  }) => (
    <Controller
      control={control}
      name={name}
      rules={rules}
      defaultValue={
        typeof defaultValue === 'undefined'
          ? defaultValueFallback
          : defaultValue
      }
      render={({
        onChange, onBlur, value, ref,
      }) => (
        <ComponentWithController
          name={name}
          onChange={onChange}
          onBlur={onBlur}
          value={value}
          inputRef={ref}
          {...properties_}
        />
      )}
    />
  );

  WrappedComponent.propTypes = {
    rules: PropTypes.shape({}),
    name: PropTypes.string.isRequired,
    control: PropTypes.shape({}).isRequired,
    defaultValue: PropTypes.oneOfType([
      PropTypes.string,
      PropTypes.number,
      PropTypes.bool,
      PropTypes.arrayOf(PropTypes.string),
      PropTypes.shape({}),
    ]),
  };

  WrappedComponent.defaultProps = {
    rules: undefined,
    defaultValue: undefined,
  };

  return WrappedComponent;
};

export default withController;
